import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Point de montage React introuvable");

createRoot(root).render(<App />);
